(() => {
  if (window.__LIF_CHAT_WIDGET_INITIALIZED__) {
    const oldRoot = document.getElementById("lif-chat-root");
    if (oldRoot) oldRoot.remove();
  }
  window.__LIF_CHAT_WIDGET_INITIALIZED__ = true;

  const cfg = window.LIF_CHAT_CONFIG || {};
  const API_URL = cfg.apiUrl;
  if (!API_URL) return;

  const C = Object.assign(
    {
      bg: "#12120C",
      card: "#262617",
      gold: "#C4C964",
      text: "#E6E6D8",
      error: "#D33C3C"
    },
    cfg.brand || {}
  );

  const STYLE_ID = "lif-chat-styles-v13-atlas-mobile-fix";
  const oldStyle = document.getElementById(STYLE_ID);
  if (oldStyle) oldStyle.remove();

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    :root{
      --lif-bg:${C.bg};
      --lif-card:${C.card};
      --lif-gold:${C.gold};
      --lif-text:${C.text};
      --lif-error:${C.error};
      --lif-safe-top: env(safe-area-inset-top, 0px);
      --lif-safe-right: env(safe-area-inset-right, 0px);
      --lif-safe-bottom: env(safe-area-inset-bottom, 0px);
      --lif-safe-left: env(safe-area-inset-left, 0px);
      --lif-fab-size: 62px;
      --lif-panel-width: 410px;
      --lif-radius: 20px;
      --lif-z-overlay: 2147483644;
      --lif-z-panel: 2147483646;
      --lif-z-fab: 2147483647;
    }

    html.lif-chat-lock,
    body.lif-chat-lock{
      overflow:hidden !important;
      touch-action:none;
    }

    #lif-chat-root,
    #lif-chat-root *{
      box-sizing:border-box;
      font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;
    }

    #lif-chat-overlay{
      position:fixed;
      inset:0;
      z-index:var(--lif-z-overlay);
      background:rgba(0,0,0,.32);
      backdrop-filter:blur(3px);
      -webkit-backdrop-filter:blur(3px);
      opacity:0;
      pointer-events:none;
      transition:opacity .22s ease;
    }

    #lif-chat-overlay[data-open="1"]{
      opacity:1;
      pointer-events:auto;
    }

    #lif-chat-fab{
      position:fixed;
      right:max(16px, calc(var(--lif-safe-right) + 16px));
      bottom:max(96px, calc(var(--lif-safe-bottom) + 22px));
      z-index:var(--lif-z-fab);
      width:var(--lif-fab-size);
      height:var(--lif-fab-size);
      border:none;
      border-radius:999px;
      cursor:pointer;
      display:flex;
      align-items:center;
      justify-content:center;
      color:#161616;
      background:
        radial-gradient(circle at 30% 28%, rgba(255,255,255,.32), transparent 34%),
        linear-gradient(180deg, #dbe173 0%, var(--lif-gold) 100%);
      box-shadow:
        0 14px 34px rgba(0,0,0,.34),
        0 0 0 1px rgba(255,255,255,.12) inset,
        0 0 24px rgba(196,201,100,.26);
      transition:transform .18s ease, opacity .18s ease, box-shadow .18s ease, filter .18s ease;
      -webkit-tap-highlight-color:transparent;
      animation: lifFabFloat 2.8s ease-in-out infinite;
    }

    #lif-chat-fab:hover{
      transform:translateY(-2px) scale(1.04);
      filter:brightness(1.03);
    }

    #lif-chat-fab:active{
      transform:scale(.97);
    }

    #lif-chat-fab[data-open="1"]{
      opacity:0;
      pointer-events:none;
      transform:scale(.84);
      animation:none;
    }

    #lif-chat-fab svg{
      width:27px;
      height:27px;
      position:relative;
      z-index:2;
    }

    #lif-chat-fab::before{
      content:"";
      position:absolute;
      inset:-8px;
      border-radius:999px;
      border:1px solid rgba(196,201,100,.28);
      opacity:0;
      pointer-events:none;
      animation: lifRing 2.4s ease-out infinite;
    }

    #lif-chat-fab::after{
      content:"";
      position:absolute;
      top:7px;
      right:7px;
      width:10px;
      height:10px;
      border-radius:999px;
      background:#fff;
      box-shadow:0 0 0 2px rgba(18,18,12,.92), 0 0 10px rgba(255,255,255,.72);
      animation: lifDot 1.8s ease-in-out infinite;
    }

    @keyframes lifFabFloat{
      0%,100%{ transform:translateY(0); }
      50%{ transform:translateY(-4px); }
    }

    @keyframes lifRing{
      0%{ transform:scale(.92); opacity:0; }
      26%{ opacity:.36; }
      100%{ transform:scale(1.42); opacity:0; }
    }

    @keyframes lifDot{
      0%,100%{ transform:scale(1); opacity:.92; }
      50%{ transform:scale(1.18); opacity:1; }
    }

    #lif-chat-panel{
      position:fixed;
      right:max(18px, calc(var(--lif-safe-right) + 18px));
      bottom:max(128px, calc(var(--lif-safe-bottom) + 118px));
      z-index:var(--lif-z-panel);
      width:min(var(--lif-panel-width), calc(100vw - 36px));
      height:min(650px, calc(100dvh - 155px));
      max-height:calc(100dvh - 140px);
      display:grid;
      grid-template-rows:auto minmax(0,1fr) auto auto;
      background:var(--lif-bg);
      color:var(--lif-text);
      border:1px solid rgba(196,201,100,.22);
      border-radius:var(--lif-radius);
      overflow:hidden;
      box-shadow:0 28px 68px rgba(0,0,0,.52);
      opacity:0;
      transform:translateY(16px) scale(.98);
      pointer-events:none;
      transition:opacity .22s ease, transform .22s ease;
    }

    #lif-chat-panel[data-open="1"]{
      opacity:1;
      transform:translateY(0) scale(1);
      pointer-events:auto;
    }

    #lif-chat-head{
      min-height:72px;
      display:flex;
      align-items:flex-start;
      justify-content:space-between;
      gap:12px;
      padding:14px 14px 12px;
      background:linear-gradient(180deg, rgba(196,201,100,.16), rgba(196,201,100,0));
      border-bottom:1px solid rgba(196,201,100,.16);
    }

    #lif-chat-head-left{
      min-width:0;
      flex:1 1 auto;
      padding-right:4px;
    }

    #lif-chat-title{
      font-size:15px;
      line-height:1.2;
      font-weight:850;
      color:var(--lif-gold);
      margin:0 0 6px;
      letter-spacing:.2px;
    }

    #lif-chat-subtitle{
      font-size:12px;
      line-height:1.35;
      font-weight:500;
      color:rgba(230,230,216,.78);
      margin:0;
    }

    #lif-chat-close{
      flex:0 0 auto;
      width:46px;
      height:46px;
      border-radius:14px;
      border:1px solid rgba(255,255,255,.16);
      background:rgba(255,255,255,.08);
      color:var(--lif-text);
      display:flex;
      align-items:center;
      justify-content:center;
      font-size:28px;
      line-height:1;
      font-weight:800;
      cursor:pointer;
      -webkit-tap-highlight-color:transparent;
      transition:transform .15s ease, background .15s ease, border-color .15s ease;
    }

    #lif-chat-close:hover{
      background:rgba(255,255,255,.12);
      border-color:rgba(255,255,255,.22);
    }

    #lif-chat-close:active{
      transform:scale(.96);
    }

    #lif-chat-body{
      min-height:0;
      overflow:auto;
      overscroll-behavior:contain;
      -webkit-overflow-scrolling:touch;
      padding:13px;
      display:flex;
      flex-direction:column;
      gap:10px;
      scrollbar-color:rgba(196,201,100,.34) transparent;
    }

    .lif-msg{
      max-width:90%;
      padding:12px 13px;
      border-radius:16px;
      font-size:14px;
      line-height:1.5;
      white-space:pre-wrap;
      overflow-wrap:anywhere;
      word-break:break-word;
    }

    .lif-msg.user{
      margin-left:auto;
      background:var(--lif-card);
      color:var(--lif-text);
      border:1px solid rgba(255,255,255,.10);
    }

    .lif-msg.bot{
      margin-right:auto;
      background:rgba(196,201,100,.11);
      color:var(--lif-text);
      border:1px solid rgba(196,201,100,.20);
    }

    .lif-msg.bot a{
      color:var(--lif-gold);
      text-decoration:underline;
      text-underline-offset:2px;
      word-break:break-all;
    }

    #lif-chat-quick{
      display:flex;
      gap:8px;
      padding:0 13px 11px;
      overflow-x:auto;
      overflow-y:hidden;
      -webkit-overflow-scrolling:touch;
      scrollbar-width:none;
      white-space:nowrap;
    }

    #lif-chat-quick::-webkit-scrollbar{
      display:none;
    }

    .lif-quick-btn{
      flex:0 0 auto;
      appearance:none;
      border:1px solid rgba(196,201,100,.24);
      background:rgba(196,201,100,.09);
      color:var(--lif-text);
      border-radius:999px;
      padding:10px 13px;
      font-size:12px;
      line-height:1.15;
      font-weight:750;
      cursor:pointer;
      white-space:nowrap;
      -webkit-tap-highlight-color:transparent;
      transition:background .15s ease, transform .15s ease, border-color .15s ease;
    }

    .lif-quick-btn:hover{
      background:rgba(196,201,100,.16);
      border-color:rgba(196,201,100,.38);
    }

    .lif-quick-btn:active{
      transform:scale(.98);
    }

    .lif-quick-btn[disabled]{
      opacity:.6;
      cursor:not-allowed;
    }

    #lif-chat-foot{
      display:grid;
      grid-template-columns:minmax(0,1fr) auto;
      gap:8px;
      padding:11px 13px 13px;
      background:rgba(38,38,23,.86);
      border-top:1px solid rgba(196,201,100,.16);
    }

    #lif-chat-input{
      width:100%;
      min-width:0;
      height:50px;
      border-radius:15px;
      border:1px solid rgba(255,255,255,.14);
      background:rgba(18,18,12,.90);
      color:var(--lif-text);
      padding:0 14px;
      font-size:15px;
      outline:none;
    }

    #lif-chat-input::placeholder{
      color:rgba(230,230,216,.48);
    }

    #lif-chat-input:focus{
      border-color:rgba(196,201,100,.42);
      box-shadow:0 0 0 3px rgba(196,201,100,.10);
    }

    #lif-chat-send{
      min-width:96px;
      height:50px;
      border:none;
      border-radius:15px;
      background:var(--lif-gold);
      color:#111;
      font-size:13px;
      font-weight:850;
      padding:0 16px;
      cursor:pointer;
      white-space:nowrap;
      -webkit-tap-highlight-color:transparent;
      transition:transform .15s ease, filter .15s ease, opacity .15s ease;
    }

    #lif-chat-send:hover{
      filter:brightness(1.04);
    }

    #lif-chat-send:active{
      transform:scale(.98);
    }

    #lif-chat-send[disabled]{
      opacity:.65;
      cursor:not-allowed;
    }

    .lif-chat-typing{
      display:inline-flex;
      align-items:center;
      gap:4px;
    }

    .lif-chat-typing span{
      width:6px;
      height:6px;
      border-radius:999px;
      background:var(--lif-gold);
      opacity:.4;
      animation:lifTyping 1.05s infinite ease-in-out;
    }

    .lif-chat-typing span:nth-child(2){ animation-delay:.15s; }
    .lif-chat-typing span:nth-child(3){ animation-delay:.30s; }

    @keyframes lifTyping{
      0%,80%,100%{ transform:translateY(0); opacity:.35; }
      40%{ transform:translateY(-3px); opacity:1; }
    }

    @media (max-width: 768px){
      #lif-chat-fab{
        right:max(14px, calc(var(--lif-safe-right) + 14px));
        bottom:max(98px, calc(var(--lif-safe-bottom) + 22px));
        width:58px;
        height:58px;
      }

      #lif-chat-panel{
        left:50% !important;
        right:auto !important;
        bottom:max(98px, calc(var(--lif-safe-bottom) + 92px)) !important;
        width:90vw !important;
        max-width:90vw !important;
        height:68vh !important;
        max-height:68vh !important;
        border-radius:18px !important;
        transform:translateX(-50%) translateY(16px) scale(.98) !important;
      }

      #lif-chat-panel[data-open="1"]{
        transform:translateX(-50%) translateY(0) scale(1) !important;
      }

      #lif-chat-head{
        min-height:auto;
        padding:12px 12px 10px;
        gap:8px;
      }

      #lif-chat-title{
        font-size:16px;
        line-height:1.15;
      }

      #lif-chat-subtitle{
        font-size:12px;
        line-height:1.28;
      }

      #lif-chat-close{
        width:44px;
        height:44px;
        border-radius:14px;
        font-size:28px;
      }

      #lif-chat-body{
        padding:10px;
      }

      .lif-msg{
        max-width:96%;
        font-size:14px;
        line-height:1.42;
        padding:11px 12px;
      }

      #lif-chat-quick{
        padding:0 10px 10px;
        gap:7px;
      }

      .lif-quick-btn{
        padding:9px 11px;
        font-size:12px;
      }

      #lif-chat-foot{
        grid-template-columns:minmax(0,1fr) 72px;
        gap:7px;
        padding:9px 10px 10px;
      }

      #lif-chat-input{
        height:46px;
        font-size:16px;
        padding:0 11px;
      }

      #lif-chat-send{
        min-width:72px;
        height:46px;
        padding:0 10px;
        font-size:12.5px;
      }
    }

    @media (max-width: 390px){
      #lif-chat-panel{
        width:88vw !important;
        max-width:88vw !important;
        height:66vh !important;
        max-height:66vh !important;
        bottom:max(96px, calc(var(--lif-safe-bottom) + 88px)) !important;
      }

      #lif-chat-foot{
        grid-template-columns:minmax(0,1fr) 68px;
      }

      #lif-chat-send{
        min-width:68px;
        padding:0 9px;
      }

      .lif-msg{
        font-size:13.5px;
      }
    }

    @media (prefers-reduced-motion: reduce){
      #lif-chat-fab,
      #lif-chat-fab::before,
      #lif-chat-fab::after,
      .lif-chat-typing span{
        animation:none !important;
      }

      #lif-chat-overlay,
      #lif-chat-panel,
      #lif-chat-fab{
        transition:none !important;
      }
    }
  `;
  document.head.appendChild(style);

  const oldRoot = document.getElementById("lif-chat-root");
  if (oldRoot) oldRoot.remove();

  const root = document.createElement("div");
  root.id = "lif-chat-root";
  root.innerHTML = `
    <div id="lif-chat-overlay" data-open="0"></div>

    <button id="lif-chat-fab" type="button" aria-label="Chat megnyitása" data-open="0">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5.5C4 4.12 5.12 3 6.5 3h11C19.88 3 21 4.12 21 5.5v8C21 14.88 19.88 16 18.5 16H9l-4.2 3.2c-.5.38-1.2.02-1.2-.6V5.5Z" stroke="currentColor" stroke-width="1.7"/>
        <path d="M7 7.5h10M7 11h7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </svg>
    </button>

    <section id="lif-chat-panel" data-open="0" aria-hidden="true">
      <div id="lif-chat-head">
        <div id="lif-chat-head-left">
          <div id="lif-chat-title">LIF Academy Assistant</div>
          <div id="lif-chat-subtitle">Kérdezz röviden. Megmutatom, melyik rendszer mire való.</div>
        </div>
        <button id="lif-chat-close" type="button" aria-label="Bezárás">×</button>
      </div>

      <div id="lif-chat-body"></div>

      <div id="lif-chat-quick">
        <button class="lif-quick-btn" type="button" data-q="Mi a különbség a hullámgenetikai mátrixok és a ZenPeak modulátor között?">Mátrix vs Modulátor</button>
        <button class="lif-quick-btn" type="button" data-q="Melyik termék a legjobb belépési pont, ha most akarok elkezdeni valamit?">Mivel kezdjek?</button>
        <button class="lif-quick-btn" type="button" data-q="Mutasd meg röviden, melyik rendszer mire való a LIF Academy-nél.">Mire való?</button>
      </div>

      <form id="lif-chat-foot">
        <input id="lif-chat-input" type="text" autocomplete="off" placeholder="Írj ide..." />
        <button id="lif-chat-send" type="submit">Küldés</button>
      </form>
    </section>
  `;
  document.body.appendChild(root);

  const overlay = root.querySelector("#lif-chat-overlay");
  const fab = root.querySelector("#lif-chat-fab");
  const panel = root.querySelector("#lif-chat-panel");
  const closeBtn = root.querySelector("#lif-chat-close");
  const bodyEl = root.querySelector("#lif-chat-body");
  const form = root.querySelector("#lif-chat-foot");
  const input = root.querySelector("#lif-chat-input");
  const sendBtn = root.querySelector("#lif-chat-send");
  const quickBtns = [...root.querySelectorAll(".lif-quick-btn")];

  const STORAGE_KEY = "lif_chat_history_v13";
  const VISITOR_KEY = "lif_atlas_visitor_id";

  let isOpen = false;
  let isSending = false;

  function getVisitorId() {
    try {
      let id = localStorage.getItem(VISITOR_KEY);
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(VISITOR_KEY, id);
      }
      return id;
    } catch {
      return "visitor_" + Math.random().toString(36).slice(2);
    }
  }

  const visitorId = getVisitorId();

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function linkify(text) {
    const escaped = escapeHtml(text);
    return escaped.replace(
      /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/g,
      (url) => `<a href="${url.replace(/&amp;/g, "&")}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  }

  function loadHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.slice(-20) : [];
    } catch {
      return [];
    }
  }

  function saveHistory(history) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(-20)));
    } catch {}
  }

  let history = loadHistory();

  function scrollToBottom(smooth = false) {
    bodyEl.scrollTo({
      top: bodyEl.scrollHeight,
      behavior: smooth ? "smooth" : "auto"
    });
  }

  function addMsg(role, content, html = false) {
    const el = document.createElement("div");
    el.className = `lif-msg ${role === "assistant" ? "bot" : "user"}`;
    if (html) el.innerHTML = content;
    else if (role === "assistant") el.innerHTML = linkify(content);
    else el.textContent = content;
    bodyEl.appendChild(el);
    scrollToBottom();
    return el;
  }

  function addTyping() {
    return addMsg(
      "assistant",
      `<span class="lif-chat-typing"><span></span><span></span><span></span></span>`,
      true
    );
  }

  if (history.length) {
    history.forEach((m) => addMsg(m.role, m.content));
  } else {
    addMsg(
      "assistant",
      "Szia! Írd meg röviden, mit keresel: mátrixot, ZenPeak rendszert, vagy egy gyors kezdő ajánlást."
    );
  }

  function lockPage(locked) {
    document.documentElement.classList.toggle("lif-chat-lock", locked);
    document.body.classList.toggle("lif-chat-lock", locked);
  }

  function setOpen(open) {
    isOpen = !!open;

    overlay.setAttribute("data-open", isOpen ? "1" : "0");
    panel.setAttribute("data-open", isOpen ? "1" : "0");
    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    fab.setAttribute("data-open", isOpen ? "1" : "0");

    lockPage(isOpen);

    if (isOpen) {
      setTimeout(() => {
        try { input.focus({ preventScroll: true }); } catch { input.focus(); }
        scrollToBottom();
      }, 80);
    } else {
      input.blur();
    }
  }

  function setSending(sending) {
    isSending = !!sending;
    input.disabled = isSending;
    sendBtn.disabled = isSending;
    quickBtns.forEach((btn) => { btn.disabled = isSending; });
  }

  async function sendMessage(text) {
    const trimmed = String(text || "").trim();
    if (!trimmed || isSending) return;

    setOpen(true);

    addMsg("user", trimmed);
    history.push({ role: "user", content: trimmed });
    saveHistory(history);

    setSending(true);
    const typingEl = addTyping();

    const payload = {
      visitor_id: visitorId,
      message: trimmed,
      history: history.slice(-6),
      page: {
        title: document.title,
        url: location.href
      },
      context: {
        path: location.pathname
      }
    };

    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const raw = await res.text();

      let data = null;
      try {
        data = JSON.parse(raw);
      } catch {
        throw new Error("Nem JSON válasz: " + raw.slice(0, 300));
      }

      if (!res.ok) {
        throw new Error("HTTP " + res.status + " | " + JSON.stringify(data).slice(0, 500));
      }

      if (!data.answer) {
        throw new Error("Nincs answer mező | " + JSON.stringify(data).slice(0, 500));
      }

      typingEl.innerHTML = linkify(data.answer);

      history.push({ role: "assistant", content: data.answer });
      saveHistory(history);

      scrollToBottom(true);
    } catch (err) {
      console.error("LIF chat error:", err);

      typingEl.textContent =
        "Technikai hiba történt: " +
        (err && err.message ? err.message : "ismeretlen hiba");

      scrollToBottom(true);
    } finally {
      setSending(false);
      setTimeout(() => {
        try { input.focus({ preventScroll: true }); } catch { input.focus(); }
      }, 60);
    }
  }

  fab.addEventListener("click", () => setOpen(true));
  closeBtn.addEventListener("click", () => setOpen(false));
  overlay.addEventListener("click", () => setOpen(false));

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const text = input.value.trim();
    if (!text) return;
    input.value = "";
    sendMessage(text);
  });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit();
    }
  });

  quickBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const q = btn.getAttribute("data-q");
      if (q) sendMessage(q);
    });
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen) setOpen(false);
  });

  window.addEventListener("resize", () => {
    if (isOpen) scrollToBottom();
  });

  window.addEventListener("orientationchange", () => {
    setTimeout(() => {
      if (isOpen) scrollToBottom();
    }, 250);
  });
})();